/**
 * Tram point machine
 * - used in Olsztyn
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Pme extends Element {
  constructor (attrs) {
    super(attrs)
    // Status properties
    // enumPos (left, right, mid)
    if (this.statusBit(2)) { this.enumPos = 'mid' } else if (this.statusBit(0)) { this.enumPos = 'left' } else if (this.statusBit(1)) { this.enumPos = 'right' }
  }

  setDefaultShapes () {
    this.shapes = [
      new Ren.Circle({
        name: 'circleAround',
        x: 0,
        y: 0,
        radius: 20,
        opacity: 0.2
      }),
      new Ren.Circle({
        name: 'circleUnder',
        x: 0,
        y: 0,
        radius: 20,
        opacity: 1,
        strokeEnabled: false,
        fill: Color.white
      })
    ]

    if (this.elementTypeName === 'Pme_left') {
      // default
      this.shapes.push(
        new Ren.Line({
          points: [0, 20, 0, 0],
          lineCap: 'round'
        }),
        new Ren.Line({
          name: 'left',
          points: [0, 0, -20, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Line({
          name: 'right',
          points: [0, 0, 0, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Circle({
          name: 'onlineStatus',
          x: +11,
          y: -20,
          radius: 3,
          opacity: 1,
          fill: 'red'
        })
      )
    }

    if (this.elementTypeName === 'Pme_y') {
      // default
      this.shapes.push(
        new Ren.Line({
          points: [0, 20, 0, 0],
          lineCap: 'round'
        }),
        new Ren.Line({
          name: 'left',
          points: [0, 0, -20, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Line({
          name: 'right',
          points: [0, 0, 20, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Circle({
          name: 'onlineStatus',
          x: +11,
          y: -20,
          radius: 3,
          opacity: 1,
          fill: 'red'
        })
      )
    }

    if (this.elementTypeName === 'Pme_right') {
      // default
      this.shapes.push(
        new Ren.Line({
          points: [0, 20, 0, 0],
          lineCap: 'round'
        }),
        new Ren.Line({
          name: 'left',
          points: [0, 0, 0, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Line({
          name: 'right',
          points: [0, 0, 20, -20],
          lineCap: 'round',
          visible: true
        }),
        new Ren.Circle({
          name: 'onlineStatus',
          x: -10,
          y: -20,
          radius: 3,
          opacity: 1,
          fill: 'red'
        })
      )
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    // variable: position
    if (status.position === 1) {
      this.modifyShape('left', 'visible', false)
      this.modifyShape('right', 'visible', false)
    } else if (status.position === 0) {
      this.modifyShape('left', 'visible', true)
      this.modifyShape('right', 'visible', false)
    } else if (status.position === 2) {
      this.modifyShape('left', 'visible', false)
      this.modifyShape('right', 'visible', true)
    }
  }
}
